import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52995c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-[calc(100vh-60px)] flex flex-col items-center tablet:flex-row-reverse" }
const _hoisted_2 = { class: "flex flex-col items-center gap-10 py-10 px-[5%] h-[450px] justify-center tablet:w-3/5 tablet:h-[calc(100vh-60px)] tablet:min-h-[450px]" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-[250px] tablet:w-[350px]" }, "Pro vstup do sekce pro členy je nutné zadat přístupové heslo", -1))
const _hoisted_4 = {
  class: "text-xs text-red-500 p-3",
  id: "wrongPassword"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "group w-full h-[400px] relative shadow-xl flex flex-col items-center justify-center tablet:w-2/5 tablet:h-[calc(100vh-60px)] tablet:min-h-[450px]",
  id: "imageBox"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/obrazky/login.jpg",
    alt: "",
    class: "object-cover w-full h-full"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-black bg-opacity-60 absolute top-0 h-full w-full" }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl absolute m-auto left-0 right-0 text-white font-bold px-[10%] tablet:px-[3%]" }, [
    /*#__PURE__*/_createTextVNode("Informace "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" pro členy")
  ])
], -1))

import CustomButton from "@/components/Base/CustomButton.vue";
  import {  ref} from "vue";
  import router from "@/router";
  import correctHashes from "../../public/data/password";

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {


  const wrongPassword = ref(false)
  const input = ref<string>('')
  const inputHash = ref<string>('')

  function validatePassword(){
    generatePasswordHash(input.value).then(() => {
      const index = correctHashes.findIndex(element => {
        return element.toLowerCase() === inputHash.value.toLowerCase()
      })
      index !== -1 ? createCookie() : handleWrongPassword()
    })
  }

  function createCookie(){
    const currentDate = new Date()
    currentDate.setMinutes(currentDate.getMinutes()+5)
    document.cookie = "SKTraskoCookie=obsahCookie; expires=" + currentDate.toUTCString()
    router.push('/pro_cleny')
  }

  document.addEventListener("keypress", function(event) {
    if (event.key === "Enter") {
      const inputEl = document.getElementById("input")
      event.preventDefault();
      validatePassword()
    }
  });

  async function generatePasswordHash(pass: string) {
    const password = pass;
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hash = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hash));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    inputHash.value = hashHex
  }


  async function handleWrongPassword(){
    wrongPassword.value = true
    const el = document.getElementById('wrongPassword')
    console.log(el)
    if(el !== null){
      el.classList.add('pulseClass')
    }
    await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
    el?.classList.remove('pulseClass')

  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "heslo",
          type: "password",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
          id: "input",
          class: "py-3 px-5 w-[200px] text-center tablet:text-left tablet:w-auto border-b-2 outline-none focus:outline-none focus:border-b-green focus:px-7 transition ease-in-out transition-all duration-200"
        }, null, 512), [
          [_vModelText, input.value]
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_4, "Nesprávné heslo", 512), [
          [_vShow, wrongPassword.value]
        ])
      ]),
      _createVNode(CustomButton, {
        value: "Přihlásit se",
        "bg-color": "bg-green",
        "text-color": "text-white",
        onClick: validatePassword
      })
    ]),
    _hoisted_5
  ]))
}
}

})